import { render, staticRenderFns } from "./CreateFAQ.vue?vue&type=template&id=6d5ec2ce&scoped=true"
import script from "./CreateFAQ.vue?vue&type=script&lang=js"
export * from "./CreateFAQ.vue?vue&type=script&lang=js"
import style0 from "./CreateFAQ.vue?vue&type=style&index=0&id=6d5ec2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ec2ce",
  null
  
)

export default component.exports